import axios from 'axios'

import {
  BulkRejectRowError,
  BulkRejectRowErrorCode
} from '@percent/admin-dashboard/api/actions/agentVerification/agentVerification.types'

const rowErrorCodes: string[] = Object.values(BulkRejectRowErrorCode)

const isRowError = (value: unknown): value is BulkRejectRowError =>
  typeof value === 'object' &&
  value !== null &&
  'row' in value &&
  typeof value.row === 'number' &&
  'field' in value &&
  typeof value.field === 'string' &&
  'message' in value &&
  typeof value.message === 'string' &&
  'code' in value &&
  typeof value.code === 'string' &&
  rowErrorCodes.includes(value.code) &&
  (!('fieldValue' in value) || value.fieldValue === undefined || typeof value.fieldValue === 'string')

export const getBulkRejectRowErrors = (err: unknown): BulkRejectRowError[] => {
  if (!axios.isAxiosError(err)) return []

  const rowErrors = err.response?.data?.error?.rowErrors

  return Array.isArray(rowErrors) ? rowErrors.filter(isRowError) : []
}
